<template>
    <div class="loading_container">
        <div class="loader_wrapper">
            <span class="loader"></span>
        </div>
    </div>
</template>

<style scoped>
.loading_container {
  position: relative;
  width: 100%;
  min-height: 500px;
  height: 100%;
}

.loader_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.loader {
    width: 48px;
    height: 48px;
    border: 5px solid #fff;
    border-bottom-color: #ff3d00;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
